function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape 2");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "pub",
  transform: "translate(-5.000000, 0.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Combined-Shape-2",
  transform: "translate(5.000000, -0.000000)"
}, React.createElement("path", {
  d: "M2,15 L16,15 L16,7 L6.50182756,7 L2,7 L2,15 Z M2,17 L2,26 L16,26 L16,17 L2,17 Z M0.060259943,5 L0.0546270184,4.95022534 L16,3.5105252e-13 L16.0102598,5 L18,5 L18,28 L0,28 L0,5 L0.060259943,5 Z M6.63988646,5 L14.0102556,5 L14.0055634,2.71333284 L6.63988646,5 Z",
  id: "Combined-Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "18px",
    height: "28px",
    viewBox: "0 0 18 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/pub.58624262.svg";
export { SvgComponent as ReactComponent };